import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
  createRoutableExtension,
} from "@backstage/core-plugin-api";
import { jiraApiRef, JiraApi } from "./api/JiraApi";
import { rootRouteRef } from "./routes";
import { Entity } from "@backstage/catalog-model";
import { JIRA_PROJECT_KEY } from "@internal/plugin-jira-api/";

export const jiraApiPlugin = createPlugin({
  id: "jira-api",
  apis: [
    createApiFactory({
      api: jiraApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new JiraApi({
          discoveryApi,
          identityApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const IssueFormOverview = jiraApiPlugin.provide(
  createRoutableExtension({
    name: "IssueFormOverview",
    component: () =>
      import("./components/IssueFormOverview").then((m) => m.IssueFormOverview),
    mountPoint: rootRouteRef,
  })
);

export const isJiraProjectAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[JIRA_PROJECT_KEY]);
